/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

const initialFormErrorsCampaignState = {
  main: false,
  campaign_type: false,
  campaign_name: false,
  general: false,
  targeting: false,
  bidding: false,
  creatives: false,
  conversionTracking: false,
  creativesConversionTracking: false, // used in creatives if there is a custom tracking errors
};

const FormErrorsCampaignSlice = createSlice({
  name: 'formErrorsCampaign',
  initialState: initialFormErrorsCampaignState,
  reducers: {
    updateBidding: (state, action) => {
      state.bidding = action.payload;
    },
    updateErrorField: (state, action) => {
      const errorField = action.payload.errorField;
      state[errorField] = action.payload.newValue;
    },
    resetErrors: (state) => {
      for (const field in state) {
        if (state[field]) state[field] = false;
      }
    },
  },
});

export const formErrorsCampaign_action = FormErrorsCampaignSlice.actions;
export default FormErrorsCampaignSlice.reducer;
